import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ChannelEntityDataObject } from 'models/service';
import type { ChannelEntityType } from '../types';

export const getChannelEntities = async (
  channelId: string,
  params: {
    featured?: boolean;
    limit?: number;
    offset?: number;
    subject?: ChannelEntityType;
  },
) =>
  apiClient.get<ChannelEntityDataObject[], ApiClientResponse<ChannelEntityDataObject[]>>(
    routes.channels.entities.get(channelId),
    {
      params,
    },
  );
